import { AutoComplete } from 'antd/lib'
import styled from 'styled-components'

const StyledAutocomplete = styled(AutoComplete)`
  width: 100%;
`

const MaterialLabelContainer = styled.div`
  margin-top: 0.35rem;
  margin-bottom: 0.5rem;
`

export { MaterialLabelContainer, StyledAutocomplete }
